// extracted by mini-css-extract-plugin
export default {"variables":"\"../../../variables.css\"","medium-768":"min-width: 768px","Backdrop":"Backdrop_Backdrop__mRasm"};